export const ApplicationConstant = {
    ApplicationID : 12,
    clientId : 8,
    organizationId: 8,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 13
}